<div class="autocomplete">
    <div class="input-icon">
        <input [(ngModel)]="input" 
               class="form-control" 
               type="text"
               (keyup)="getAllItems()"
               placeholder="{{placeholder || 'Pretraži'}}">
        <div class="input-icon-addon">
            <i class="fe fe-search"></i>
        </div>
    </div>

    <div class="autocomplete__list" *ngIf="isListVisible">
        <div class="autocomplete__item"
             *ngFor="let item of items; trackBy: trackByFn"
             (click)="onSelect(item)">
            {{ item.upisId }}-{{ item.name }}
        </div>
    </div>
</div>
